export default __webpack_public_path__ + "static/media/grade-school-2.5b22c1d9.jpg";